import React from "react";

const GoogleAdwords = () => {
  return (
    <>
      <div className="info">
        {" "}
        Google AdWords es una manera rápida y sencilla de anunciarse en Google.
        Los anuncios de Google AdWords se muestran junto con los resultados de
        búsqueda de Google, así como en los sitios de búsqueda y contenido en la
        creciente red de Google, que incluye páginas como AOL, EarthLink,
        HowStuffWorks y Blogger. Gracias a las búsquedas en Google y a las
        visitas diarias a páginas que incluyen la publicidad de Google Adwords,
        sus anuncios de Google AdWords llegan a un amplio público.
        <h4> Beneficios</h4>
        <ul>
          <li>Activación Inmediata.</li>
          <li>Inversión Controlada.</li>
          <li>Ajustes en Tiempo Real.</li>
          <li>Incentivos para los anuncios de Mejor Calidad.</li>
          <li>
            Georeferenciación que permite definir la Ubicación de los Usuarios.
          </li>
          <li>Mejor alcance.</li>
        </ul>
      </div>
    </>
  );
};

export default GoogleAdwords;
